import { render } from "./Divider.vue?vue&type=template&id=6cd00f66"
const script = {}

import "./Divider.vue?vue&type=style&index=0&id=6cd00f66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__